import React from 'react';
import './ProductV2.css';

// Products tab sub-navigation — mirrors the Voucher V2 SubNav look so the
// Products area reads consistently with Vouchers V2. Self-contained styles
// (pv2-*) so it doesn't pull the existing product page into the voucher scope.
const TABS = [
  { id: 'products', label: 'Products' },
  // 'Data' (sales analytics) hidden for launch — it exposes revenue figures
  // and needs role-based access before anyone but the owner should see it.
  // Restore { id: 'sales', label: 'Data' } when roles land.
  { id: 'orders',   label: 'Orders' },
  { id: 'store',    label: 'Store' },
];

const ProductSubNav = ({ active, onChange, counts = {}, visible = null }) => (
  <div className="pv2-subnav" role="tablist">
    {TABS.filter((tab) => !visible || visible.includes(tab.id)).map((tab) => {
      const count = counts[tab.id];
      const isActive = active === tab.id;
      return (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={isActive}
          className={`pv2-subnav-tab ${isActive ? 'active' : ''}`}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
          {count != null && <span className="pv2-subnav-count">{count}</span>}
        </button>
      );
    })}
  </div>
);

export default ProductSubNav;
